import type {ImportHondaPartsPriceListResult} from './ImportHondaPartsPriceListResultSchema';

export type ImportHondaPartsPriceListUseCaseResult = {
  result: ImportHondaPartsPriceListResult;
};
